window._ = {
  isUndefined: require('lodash/isUndefined'),
  replace: require('lodash/replace'),
  isNil: require('lodash/isNil'),
  has: require('lodash/has'),
  isEmpty: require('lodash/isEmpty'),
  head: require('lodash/head'),
  each: require('lodash/each'),
  includes: require('lodash/includes'),
  pull: require('lodash/pull'),
  forEach: require('lodash/forEach'),
  truncate: require('lodash/truncate'),
  isElement: require('lodash/isElement'),
  isEqual: require('lodash/isEqual'),
  drop: require('lodash/drop'),
  some: require('lodash/some'),
  find: require('lodash/find'),
  cloneDeep: require('lodash/cloneDeep'),
  first: require('lodash/first'),
};

window.moment = require('moment');
moment.locale('de');
window.Calendar = require('./components/EventDatesPicker/Calendar.js');
require('url-search-params-polyfill');
require('./bootstrap/index');
